import React, { useState } from "react";
import { useSelector } from "react-redux";
import { monthsAllLang } from "../../../../shared/utils/utils";
import { getMainClasses } from "../../../../shared/utils/userDetailsUtils";
import widgetLayoutClasses from "../../../../shared/components/features/widget/Widget.module.css";
import Widget from "../../../../shared/components/features/widget/Widget";
import CalendarWeekDates from "../../../../shared/components/pages/calenderPage/calendarWidget/calendarWeekDates/CalendarWeekDates";
import CalendarWeekEvents from "../../../../shared/components/pages/calenderPage/calendarWidget/calendarWeekEvents/CalendarWeekEvents";
import ScrollLTR from "../../../../shared/components/ui/scrollLTR/ScrollLTR";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import pathRouts from "../../../../shared/enums/pathRoute";
import classes from './CalendarWidget.module.css';

const CalendarWidget = ({ mainLink = `/${pathRouts.CALENDAR}` }) => {

    const { lang } = useSelector(state => state.translate);
    const [selectedDate, setSelectedDate] = useState(new Date());

    const handleDateSelect = (e, date) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedDate(date);
    };

    return (
        <Widget
            color="#C5D7E4"
            className={classes.CalendarWidget}
            title={`${monthsAllLang[new Date().getMonth()]?.[lang]} ${new Date().getFullYear()}`}
            icon={iconsList.calendar}
            mainLink={mainLink}
            contentScrollable={false}
        >
            <div className={classes.CalendarWidgetContent}>
                <CalendarWeekDates
                    selectedDate={selectedDate}
                    onDateSelect={handleDateSelect}
                />
                <ScrollLTR height="calc(100% - 52px)" >
                    <CalendarWeekEvents
                        selectedDate={selectedDate}
                    />
                </ScrollLTR>
            </div>
        </Widget>
    );
};

export default CalendarWidget;
